<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="beast-package-list">
          <ul v-if="packages.count">
            <li class="beast-package-info" :key="pkg.id" v-for="pkg in packages.data">
              <div class="row">
                <div class="col-8 beast-package-name">
                  <router-link :to="`/package/${pkg.name}`">
                    {{pkg.name}}
                  </router-link>
                </div>
              </div>
              <div class="row">
                <div class="col-12 beast-package-desc" v-text="pkg.description"></div>
              </div>
              <div class="row" v-show="pkg.keywords && pkg.keywords.length > 0">
                <div class="col-12">
                  <ul class="beast-keyword-list">
                    <li :key="keyword" v-for="keyword in pkg.keywords">
                      <a :href="`/search?query=keywords:${encodeURIComponent(keyword)}`"
                          v-on:click.prevent="searchByKeyword(keyword)" >
                        {{keyword}}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="row">
                <div class="col-12 beast-user-info">
                  <router-link :to="`/profile/${pkg.publisher.username}`" class="beast-user-link">
                    {{pkg.publisher.fullname}}
                  </router-link>
                  <span class="beast-user-text">published {{pkg.latestVersion}}</span> &bull;
                  <span class="beast-user-text">{{extractTime(pkg.publishDate)}}</span>
                </div>
              </div>
            </li>
          </ul>
          <ul v-else-if="packageSearch">
            <li class="beast-package-none">
              <div class="row">
                <div class="col-8 beast-package-name">
                  404 Not found! :(
                </div>
              </div>
              <div class="row" v-if="toSearchQuery">
                <div class="col-12 beast-package-desc">
                  The search criteria you looked after (<strong>{{toSearchQuery}}</strong>) was unable to fetch data...
                </div>
              </div>
            </li>
          </ul>
          <ul v-else>
            <li class="beast-package-none">
              <div class="row">
                <div class="col-8 beast-package-name">
                  No packages published!
                </div>
              </div>
              <div class="row">
                <div class="col-12 beast-package-desc">
                  This {{listType}} hasn't published any packages yet.
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <pagination :current="packages.page"
                    :pages="packages.pages"
                    @pageChange="fetchData"/>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Pagination from "../utils/Pagination.vue";

export default {
  name: "BeastPackagesList",
  components: { Pagination },
  props: {
    url: {
      type: String,
      default: "/packages"
    },
    toSearchQuery: {
      type: String,
      default: ""
    },
    page: {
      type: Number,
      default: 1
    },
    size: {
      type: Number,
      default: 10
    },
    packageSearch: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    listType() {
      return this.url.indexOf("organizations") >= 0
        ? "organization"
        : "user";
    }
  },

  watch: {
    async toSearchQuery(newValue) {
      this.query = newValue;
      await this.fetchData(1);
    },
    async url() {
      await this.fetchData(1);
    }
  },

  methods: {
    extractTime(date) {
      return moment(date).fromNow();
    },

    fetchData(page) {
      this._searchRepository(page);
    },

    async _searchRepository(page = 1) {
      if (this.url === "") {
        return;
      }
      const queryParams = {
        params: {
          size: this.size,
          page
        }
      };

      if (this.query !== "") {
        queryParams.params.query = this._parseQuery();
      }

      const response = await this.axios.get(this.url, queryParams);
      this.packages = response.data;
      this.$emit("updateUrl", {
        query: this.query,
        page: this.packages.page,
        size: this.size
      });
    },

    _parseQuery() {
      if (this.query.indexOf(":") > -1) {
        return this.query;
      }
      return `name:${this.query}`;
    },

    async searchByKeyword(keyword) {
      this.$emit("keywordSearch", `keywords:${keyword}`);
    }
  },

  data() {
    return {
      query: "",
      packages: {
        data: [],
        count: 0,
        page: 0,
        pages: 0,
        size: 0
      },
    };
  },

  async beforeMount() {
    this.query = this.toSearchQuery;
    await this._searchRepository(this.page);
  }
};
</script>

<style scoped lang="scss">
  .beast-package-list {
    padding: 5px 15px;
    ul {
      list-style: none;
      padding: 0;
      li {
        &.beast-package-info, &.beast-package-none {
          display: block;
          margin-top: 15px;
          padding-top: 15px;
          border-top: 1px solid #ededed;

          &:first-child {
            border-top: none;
            margin-top: 0px;
            padding-top: 0px;
          }
        }
      }
    }

    .beast-package-name {
      font-weight: bold;
      font-size: 15pt;
      a {
        text-decoration: none;

        &:hover {
          color: $beast-dark-gray;
        }
      }
    }
    .beast-package-desc {
      font-style: italic;
    }

    .beast-user-info {
      margin-top: 8px;

      .beast-user-text {
        color: #898989;
        font-style: italic;
      }

      .beast-user-link {
        font-weight: bold;
        color: $beast-dark-gray;
        text-decoration: none;
        font-style: normal;

        &:hover {
          color: $beast-green;
        }
      }
    }

    .beast-keyword-list {
      margin-top: 8px;
      li {
        display: inline-block;
        margin-right: 6px;
        cursor: default;
        padding: 3px 8px;
        background: #dedede;
        border-radius: 5px;

        a {
          color: $beast-dark-gray;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }

  }
</style>
